import React from "react";
import { useProfile } from "../hooks/useProfile";
import { getProfileFirstName } from "../utils/profileIdentity";

const EmptyCard = ({
  styles = {},
  text = {},
  language = "en",
  title = null,
  children,
  className = "",
  userName = null,
  titleAlign = "left", // left|center|right
  actionsAlign = "flex-end", // flex-start|center|flex-end
  containerStyle = {},
  actionsStyle = {},
  hideTitle = false,
}) => {
  const { profile } = useProfile();

  // The server-confirmed name (never a stored or placeholder one).
  const getConfirmedFirstName = () => userName || getProfileFirstName(profile, language);

  const computeTitle = () => {
    if (title) {
      if (typeof title === "object") return title[language] || title.en || Object.values(title)[0];
      const titleStr = String(title || "").trim();
      return titleStr || "";
    }

    if (text && text[language] && text[language].title) return text[language].title;

    const name = getConfirmedFirstName();
    const welcomeText = text && text[language] && text[language].welcome ? text[language].welcome : null;
    if (welcomeText) return name ? `${welcomeText}, ${name}` : welcomeText;
    return name || "";
  };

  const displayTitle = computeTitle();

  const defaultCard = {
    background: "transparent",
    padding: "0.75rem 1rem",
    borderRadius: 8,
    border: "1px solid rgba(0,0,0,0.06)",
    display: "block",
  };

  const mergedStyles = {
    welcomeCard: { ...(styles.welcomeCard || styles.statCard || defaultCard), ...containerStyle },
    welcomeSection: {
      ...(styles.welcomeSection || { display: "flex", alignItems: "center", justifyContent: "space-between" }),
    },
    welcomeTitle: {
      ...(styles.welcomeTitle || { margin: 0, fontSize: "1.25rem", fontWeight: 700 }),
      textAlign: titleAlign,
    },
    actionsWrapper: { display: "flex", gap: "8px", alignItems: "center", justifyContent: actionsAlign, ...actionsStyle },
  };

  return (
    <div style={mergedStyles.welcomeCard} className={className}>
      <div style={mergedStyles.welcomeSection}>
        {!hideTitle && <h1 style={mergedStyles.welcomeTitle}>{displayTitle}</h1>}
        <div style={mergedStyles.actionsWrapper}>{children}</div>
      </div>
    </div>
  );
};


export default EmptyCard;
